import { mapActions } from 'vuex'
import { JOB_CLEAR, JOB_DETAILS } from 'store/types'

export default
{
	props:
	{
		jobId:
		{
			type:     [ Number, String ],
			required: true,
		},
	},

	watch:
	{
		jobId:
		{
			immediate: true,

			handler(jobId)
			{
				return this.loadJob({ jobId })
			},
		},
	},

	methods:
	{
		...mapActions
		(
			{
				clearJob: JOB_CLEAR,
				loadJob:  JOB_DETAILS,
			}
		),
	},

	beforeDestroy()
	{
		this.clearJob()
	},
}